import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { authToken } from '@td/api';
import { FileUploads, FileUploadsNetworkErrorModal } from '@td/file_uploads';
import { useUpdater, useFetcher, translate } from '@td/shared_utils';

export const ProviderSignatureFileUploadsContainer = props => {
  const fileUploadRequestState = useUpdater('post', {
    url:     `/providers/${props.providerId}/upload_signature`,
    method:  'post',
    baseURL: window.location.origin,
    headers: { 'Content-Type': 'multipart/form-data', Authorization: `${authToken.get()}` }
  });
  const fileTypeOptionsRequestState = useFetcher('/member_attachments/new');
  const [modalIsClosed, setClosed] = useState(true);
  const [networkError, setNetworkError] = useState(false);

  useEffect(() => {
    const uploadResponse = fileUploadRequestState.data;
    if (
      fileUploadRequestState.finished &&
      uploadResponse &&
      uploadResponse.success &&
      modalIsClosed
    ) {
      window.location.reload();
    }
    if (
      fileUploadRequestState.finished &&
      ((uploadResponse && uploadResponse.error) || fileUploadRequestState.error)
    ) {
      setClosed(true);
      setNetworkError(true);
      fileUploadRequestState.reset();
    }
  });

  return (
    <div id="admin" className="file-uploads">
      <FileUploadsNetworkErrorModal isNetworkError={networkError} setNetworkError={setNetworkError} />
      <fieldset id="file_upload">
        <FileUploads
          cssModalKey="admin"
          fileUploadRequestState={fileUploadRequestState}
          fileTypeOptionsRequestState={fileTypeOptionsRequestState}
          modalIsClosed={modalIsClosed}
          setClosed={setClosed}
          customFields={[{
            type: 'prompt',
            identifier: 'person-name-prompt',
            title: translate(null, 'uploads.general.modal.provider_name_prompt', 'title', { name: `<i>${props.providerName}</i>` }),
            missing: translate(null, 'uploads.general.modal.provider_name_prompt', 'warning'),
            choices: [{ label: null, val: props.providerName }]
          }]}
        />
      </fieldset>
    </div>
  );
};

ProviderSignatureFileUploadsContainer.propTypes = {
  providerId:   PropTypes.number.isRequired,
  providerName: PropTypes.string
};
